import React from 'react';
import { ViewportList } from 'react-viewport-list';
import classNames from 'classnames';
import Checkbox from '../../atoms/Checkbox';

export interface CheckboxListItem {
  id: string;
  title: string;
}

export interface Props extends Omit<ViewportList, 'items'> {
  items: CheckboxListItem[];
  onChange: (ids: string[]) => void;
}

const CheckboxList: React.FunctionComponent<Props> = ({
  items,
  onChange,
  ...htmlProps
}) => {
  const [selected, setSelected] = React.useState<string[]>([]);

  const handleSelectItem = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      // Reset selection if:
      //  - default (key: '') is selected
      //  - no options is selected
      if (event.target.value === '' && event.target.checked) {
        const newOptions = [''];
        setSelected(newOptions);
        onChange(newOptions);
      } else if (selected.includes('')) {
        const newOptions =
          event.target.value !== '' ? [event.target.value] : [];
        setSelected(newOptions);
        onChange(newOptions);
      } else {
        const newOptions = event.target.checked
          ? [...selected, event.target.value]
          : selected.filter((e) => e !== event.target.value);
        setSelected(newOptions);
        onChange(newOptions);
      }
    },
    [onChange, selected],
  );

  return (
    <ViewportList
      {...htmlProps}
      items={[
        {
          key: '',
          id: '',
          label: 'Todos',
          disabled: false,
        },
        ...items.map((item) => ({
          key: item.id,
          id: item.id,
          label: item.title,
          disabled: false,
        })),
      ]}
    >
      {(opt, idx) => {
        const checked = selected.includes(opt.id) || selected.includes('');

        return (
          <Checkbox
            key={opt.key ?? opt.id}
            name={`${opt.id}-${idx}`}
            className={classNames('pt-3 pr-2 pb-3 pl-2 rounded-sm', {
              'bg-blue600_25': checked,
            })}
            label={opt.label}
            value={opt.id}
            checked={checked}
            onChange={handleSelectItem}
            ellipsize={false}
            disabled={opt.disabled}
          />
        );
      }}
    </ViewportList>
  );
};

export default CheckboxList;
